enum SolveType {
  TakeLess,
  PayMore,
  EquityRelease
}

export type SolveTypeInfo = {
  value: SolveType;
  label: string;
  gerund: string;
};

export function getSolveTypeInfo(solveType: SolveType): SolveTypeInfo {
  switch (solveType) {
    case SolveType.TakeLess:
      return {
        value: solveType,
        label: "Take Less",
        gerund: "taking less"
      };
    case SolveType.PayMore:
      return {
        value: solveType,
        label: "Pay More",
        gerund: "paying more"
      };
    case SolveType.EquityRelease:
      return {
        value: solveType,
        label: "Equity Release",
        gerund: "equity release"
      };
    default:
      throw new Error("Unknown solve type.");
  }
}

export default SolveType;
